export default __webpack_public_path__ + "static/media/icon-electric-car.fa7de800.svg";